export const TEXT_COLOR = 'textColor';
export const GREY_COLOR = 'greyColor';
export const DARK_GREY_COLOR = 'darkGreyColor';
export const NEUTRAL_GREY_COLOR = 'neutralGreyColor';
export const PRIMARY_COUNTRY_COLOR = 'primaryCountryColor';
export const SECONDARY_COUNTRY_COLOR = 'secondaryCountryColor';
export const PRIMARY_CURRENT_COLOR = 'primaryCurrentColor';
export const SECONDARY_CURRENT_COLOR = 'secondaryCurrentColor';
export const PRIMARY_CURRENT_COLOR_HOVER = 'primaryCurrentColorHover';
export const LIGHT_COLOR = 'lightColor';
export const PRIMARY_COLOR = 'primaryColor';
export const PRIMARY_COLOR_HOVER = 'primaryColorHover';
export const SECONDARY_COLOR = 'secondaryColor';
export const SECONDARY_COLOR_HOVER = 'secondaryColorHover';
export const LIGHT_GREY_COLOR = 'lightGreyColor';
export const USER_PRIMARY_COUNTRY_COLOR = 'userPrimaryCountryColor';
export const USER_SECONDARY_COUNTRY_COLOR = 'userSecondaryCountryColor';
export const DANGER_COLOR = 'dangerColor';
export const DANGER_COLOR_DARK = 'dangerDarkColor';
export const DANGER_COLOR_HOVER = 'dangerColorHover';
export const WARNING_COLOR = 'warningColor';
export const WARNING_COLOR_HOVER = 'warningColorHover';
export const SUCCESS_COLOR_MID = 'successMidColor';
export const SUCCESS_COLOR_DARK = 'successDarkColor';
export const SUCCESS_COLOR_HOVER = 'successColorHover';
export const TERTIARY_COLOR = 'tertiaryColor';
export const TERTIARY_COLOR_HOVER = 'tertiaryColorHover';
export const INFOS_COLOR = 'infosDarkColor';
export const INFOS_COLOR_HOVER = 'infosColorHover';
export const FAKE_TRANSLUCENT_GREY_COLOR = 'fakeTranslucentGrey';
export const GREY_BUTTON_COLOR = 'greyButtonColor';
export const GREY_BUTTON_COLOR_HOVER = 'greyButtonColorHover';
export const GREY_MAIN_COLUMN_SLICE = 'greyMainColumnSlice';
export const WHITE_MAIN_COLUMN_SLICE = 'whiteMainColumnSlice';
export const TWITTER_COLOR = 'twitterColor';
export const TWITTER_COLOR_HOVER = 'twitterColorHover';
export const FACEBOOK_COLOR = 'facebookColor';
export const FACEBOOK_COLOR_HOVER = 'facebookColorHover';
export const FORM_FIELDS_BORDER_COLOR = 'formFieldsBorderColor';
export const TRANSPARENT_LIGHT_COLOR = 'transparentLightColor';
export const MAIN_GREY_BACKGROUND = 'mainGreyBackground';
export const TOOLTIP_COLOR = 'tooltipColor';
export const LIGHTER_GREY_COLOR = 'lighterGreyColor';
export const OVERLAY_COLOR = 'overlayColor';
export const DROP_SHADOW_COLOR = 'dropShadowColor';
export const DROP_SHADOW_DARKER_COLOR = 'dropShadowDarkerColor';
export const HEADINGS_FONT = 'headingsFont';

export default {
  // Breakpoint
  tablet: '64em', // stands for 1024px i.e. landscape tablets
  xl: '75em', // 1200px

  // Main theme colors:
  [PRIMARY_COLOR]: '#058bc4', // IFProfs primary blue
  [SECONDARY_COLOR]: '#3a3d3f', // IFProfs dark grey
  [TERTIARY_COLOR]: '#868889', // IFProfs mid grey
  [DANGER_COLOR]: '#E51E00',
  [WARNING_COLOR]: 'orange',

  // Main themecolors (hover):
  [PRIMARY_COLOR_HOVER]: '#06688f',
  [SECONDARY_COLOR_HOVER]: '#111111',
  [TERTIARY_COLOR_HOVER]: '#666',
  [DANGER_COLOR_HOVER]: '#900',
  [WARNING_COLOR_HOVER]: 'darkorange',
  [SUCCESS_COLOR_HOVER]: 'darkgreen',

  // defaut current colors
  [PRIMARY_CURRENT_COLOR]: '#058bc4', // IFProfs primary blue
  [PRIMARY_CURRENT_COLOR_HOVER]: '#06688f',
  [SECONDARY_CURRENT_COLOR]: '#06688f', // IFProfs dark grey

  // Country vars:
  [PRIMARY_COUNTRY_COLOR]: '#720000',
  [SECONDARY_COUNTRY_COLOR]: '#4d0505',
  [USER_PRIMARY_COUNTRY_COLOR]: '#000000',
  [USER_SECONDARY_COUNTRY_COLOR]: '#000000',
  [FAKE_TRANSLUCENT_GREY_COLOR]: '#D8D9DA',

  textColor: '#3a3d3f',
  [TEXT_COLOR]: '#3a3d3f',

  // Neutral colors:
  [MAIN_GREY_BACKGROUND]: '#e9eaea',
  [LIGHT_COLOR]: '#ffffff',
  [GREY_COLOR]: '#808080',
  [LIGHT_GREY_COLOR]: '#f0f0f0',
  [DARK_GREY_COLOR]: '#5c6063',
  [NEUTRAL_GREY_COLOR]: '#666666',
  tooltipColor: '#3a3d3f',
  [LIGHTER_GREY_COLOR]: '#ccc',
  lightGreyColor2: '#e7e7e7',
  lightGreyColor3: '#f2f2f2',

  // Contextual colors
  infosDarkColor: '#579',
  [INFOS_COLOR]: '#579',
  infosColorHover: '#468',
  infosLightColor: '#cef',
  dangerDarkColor: '#721c24',
  dangerLightColor: '#f8d7da',
  [SUCCESS_COLOR_DARK]: '#155724',
  successLightColor: '#c3e6cb',
  warningLightColor: '#FFF2E5',
  warningDarkColor: '#c60',
  [SUCCESS_COLOR_MID]: '#696',

  // form elements
  formFieldsBorderColor: '#dbdbdb',
  [FORM_FIELDS_BORDER_COLOR]: '#dbdbdb',

  // Transparent colors
  lightBorderColor: 'rgba(255,255,255,.2)',
  [TRANSPARENT_LIGHT_COLOR]: 'rgba(255,255,255,.1)',
  overlayColor: 'rgba(6, 104, 143, .75)',
  dropShadowColor: 'rgba(0,0,0,.2)',
  dropShadowDarkerColor: 'rgba(0,0,0,.4)',

  // Buttons color
  borderColor: '#9ea0a1',
  [GREY_BUTTON_COLOR]: '#868889',
  [GREY_BUTTON_COLOR_HOVER]: '#757575',

  //main column slice color
  [GREY_MAIN_COLUMN_SLICE]: '#f8f9f9',
  [WHITE_MAIN_COLUMN_SLICE]: 'white',

  // Social networks
  [TWITTER_COLOR]: 'rgb(29, 161, 242)',
  [TWITTER_COLOR_HOVER]: 'rgb(26, 145, 218)',
  [FACEBOOK_COLOR]: '#4267b2',
  [FACEBOOK_COLOR_HOVER]: '#365899',

  // Font names
  mainFont: "'DINOT', sans-serif",
  headingsFont: "'Klinic Slab', serif",

  // Mailings dedicated consts
  mailingsMainColor: '#009CDB',
  mailingsFont: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  mailingsTextColor: '#464847',
};
